import { Alert, BlockedState, KeyValueGrid } from "@swot/base-components";
import type { ApiDependencyError } from "../services/api.service.js";
import type { DependencyCheckResult } from "../types/api.types.js";

export function CmtsDependencyBlockerPanel({ dependencyErrors, dependencyCheck, title = "Dependency check" }: { readonly dependencyErrors?: readonly ApiDependencyError[] | undefined; readonly dependencyCheck?: DependencyCheckResult | undefined; readonly title?: string | undefined }) {
  const errors = dependencyErrors ?? [];
  const dependencies = dependencyCheck?.dependencies ?? [];
  const blocking = dependencies.filter((item) => item.blocking);
  if (!errors.length && !dependencies.length) return null;
  if (blocking.length || errors.length) {
    return (
      <BlockedState title={title} message="The requested action is blocked by active dependencies returned by the backend.">
        <ul>
          {[...errors.map((item) => ({ entity: item.entity, id: item.id, message: item.message, code: item.code })), ...blocking].map((item, index) => (
            <li key={`${item.entity ?? "dependency"}-${item.id ?? index}`}>{item.entity ? `${item.entity}: ` : ""}{item.message}{item.code ? ` (${item.code})` : ""}</li>
          ))}
        </ul>
      </BlockedState>
    );
  }
  return (
    <Alert title={title} tone="success">
      <KeyValueGrid items={[{ label: "Can delete", value: String(dependencyCheck?.canDelete ?? true) }, { label: "Can deactivate", value: String(dependencyCheck?.canDeactivate ?? true) }, { label: "Dependencies", value: String(dependencies.length) }]} />
    </Alert>
  );
}
